import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import WithHandleTouch from 'src/app/components/HOC/with_handletouch'
import {
  APPStatisticManager,
  ShenceStatisService
} from '../../../lib/statistics/app'

import './index.scss'

class Questionnaire extends React.Component {
  handleClick = data => () => {
    const { onCancel, activePayment } = this.props
    onCancel && onCancel()

    const link = data.web_route_name

    APPStatisticManager.sensor(ShenceStatisService.id).then(sensor =>
      sensor.incrementProfile(data.sensors_id)
    )

    if (_.isEmpty(link)) {
      return null
    } else if (_.includes(link, 'https')) {
      window.location.href = link
    } else if (_.includes(link, 'handlePayment')) {
      activePayment && activePayment()
    } else {
      browserHistory.push(link)
    }
  }

  _onCancel = () => {
    const { qusetion, onCancel } = this.props
    APPStatisticManager.sensor(ShenceStatisService.id).then(sensor =>
      sensor.incrementProfile(qusetion.sensors_close_id)
    )
    onCancel && onCancel()
  }

  render() {
    const { qusetion, title } = this.props
    if (_.isEmpty(qusetion)) return null

    const { description, content } = qusetion
    return (
      <div className="questionnaire-box">
        <span className="shade" />
        <div className="questionnaire-container">
          <div className="questionnaire-container-box">
            <div className="questionnaire-close" onClick={this._onCancel}>
              <span className="questionnaire-close-icon" />
            </div>
            <div className="title-wrapper-view">
              <img
                className="questionnaire-backgroundImage"
                src={qusetion.popBackgroundImage}
                alt=""
              />
              <div className="questionnaire-title">{title}</div>
              {description ? (
                <div className="questionnaire-title-sub">{description}</div>
              ) : null}
            </div>
            {_.map(content, (v, k) => {
              return (
                <div
                  onClick={this.handleClick(v)}
                  className="question-select"
                  style={{
                    display: !_.isEmpty(v.icon_url) ? 'flex' : 'block'
                  }}
                  key={k}
                >
                  <div>
                    {!_.isEmpty(v.icon_url) && (
                      <img className="select-icon" alt="" src={v.icon_url} />
                    )}
                    {v.title || v.sub_title}
                  </div>
                  {!_.isEmpty(v.icon_url) && (
                    <img
                      className="select-next"
                      alt=""
                      src={require('src/assets/images/account/next.png')}
                    />
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

Questionnaire.propTypes = {
  qusetion: PropTypes.object.isRequired,
  activePayment: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

Questionnaire.defaultProps = {
  qusetion: null,
  activePayment: () => {},
  title: ''
}

export default WithHandleTouch(Questionnaire)
